module.exports = __webpack_public_path__ + "static_web/img/qr.baffe39b.jpg";